import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDg3mTQj0aBi1yHzLDeBoyMbyB87b0rMvM",
  authDomain: "hankix.firebaseapp.com",
  databaseURL: "https://hankix.firebaseio.com",
  projectId: "hankix",
  storageBucket: "hankix.firebasestorage.app",
  messagingSenderId: "871159815572",
  appId: "1:871159815572:web:a7db68e5068d750aff4381"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
